const SectionData = {
  alias: "impress"
};

export default SectionData;
